
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingPublicStatus.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
class EvBookingPublicStatus extends compose(_StatefulSection) {
    templateString: any = template;

    publicStatusInput: MdsLax<InstanceType<typeof SearchSelect>>;
    statusCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    protected afterSetData() {
        //let data = this.currentData as VAM2types.EvBookingPublicStatus;
        let data = this.currentData as VAM2types.EvBookingIsPublicCheck;
    }

    protected onDirtyChange(currentState: boolean) {
        //let data = this.currentData as VAM2types.EvBookingPublicStatus;
        let data = this.currentData as VAM2types.EvBookingIsPublicCheck;
    }

    protected _onChanged(key: string, value: any) {
        // wird bei jedem onchanged aufgerufen
        //let data = this.currentData as VAM2types.EvBookingPublicStatus;
        let data = this.currentData as VAM2types.EvBookingIsPublicCheck;
        this.emit("changed", data.is_public);

    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.debug(this.id + " startup, Feature?", this.hasModule("EvBooking/Booker"));

        if (this.hasFeature("EvBooking/PublicStatus")) { //gültig für KBB
        //    this.publicStatusInput.setValue(window.sessionInfo?.sessionData?.CurrentEmployeeId, true);
        //    //console.debug("Loading Booker");
        //    //this.bookerInput.setUrl("EvBookingEditor/GetBookerListValues");
        //    this.publicStatusInput.setCallfunction("Webtool_API_EvBooking__GetPublicStatusListValues");
        //    this.publicStatusInput._loadListValues();
        }
    }
}

export default mdsWidget(EvBookingPublicStatus);